var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-container py32"},[_c('Header',{attrs:{"type":"alarms"}}),_c('move-horizontal-divider',{staticClass:"my32"}),_c('Alarm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }